import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "manipulation-area py-2 pl-3 pr-0" }
const _hoisted_3 = {
  key: 0,
  class: "ai-texter-table mt-2"
}
const _hoisted_4 = { class: "ai-texter-table-header" }
const _hoisted_5 = { class: "ai-texter-table-col options-column pr-0" }
const _hoisted_6 = { class: "pl-2" }
const _hoisted_7 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_8 = { class: "pl-2" }
const _hoisted_9 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_10 = { class: "pl-2" }
const _hoisted_11 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_12 = { class: "ai-texter-table-overflow-container" }
const _hoisted_13 = { class: "ai-texter-table-row-container" }
const _hoisted_14 = { class: "ai-texter-table-row-data" }
const _hoisted_15 = { class: "ai-texter-table-col options-column pr-0" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "pl-2" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "pl-2" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "pl-2" }
const _hoisted_22 = { key: 1 }

import Alert from "@common/components/Alert.vue";
import CommonFilter from "@common/components/CommonFilter.vue";
import Icon from "@common/components/Icon.vue";
import { SortedTypes } from "@medapro-types/Exports/Exports";
import _ from "lodash";
import { computed, reactive, ref } from "vue";
type ViewModel = {
  attributes: any;
  selectedErpAttributes: any;
  sortBy: { name: SortedTypes; desc: boolean };
  selectAll: any;
  searchTerm: string;
  inputIsFocused: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ErpMultiSelectList',
  props: {
    items: {}
  },
  emits: ["update:selectedItems"],
  setup(__props: any, { emit: emits }) {

const props = __props;



//#region General

//#endregion

const viewModel = reactive<ViewModel>({
  attributes: {},
  selectedErpAttributes: [],
  sortBy: { name: "", desc: false },
  selectAll: ref(false),
  searchTerm: "",
  inputIsFocused: false
});

const sortedList = computed(() => {
  const filter = viewModel.searchTerm ? viewModel.searchTerm.toLowerCase() : null;
  const filteredItems = props.items?.filter((item) => item.erpAttributeValue && item.erpAttributeValue.trim() !== "");
  const source = !filter ? filteredItems : _.filter(filteredItems, (x) => _.includes(x.erpSectionName.toLowerCase(), viewModel.searchTerm.toLowerCase()));
  const sorted = _.sortBy(source, viewModel.sortBy.name);
  return viewModel.sortBy.desc ? sorted.reverse() : sorted;
});

const setSortBy = (sortByName: SortedTypes) => {
  if (viewModel.sortBy.name != sortByName) {
    viewModel.sortBy = { name: sortByName, desc: false };
  } else {
    viewModel.sortBy.desc = !viewModel.sortBy.desc;
  }
};

const toggleSelectAll = () => {
  const isSelected = viewModel.selectAll;
  props.items.forEach((item) => (item.selected = isSelected));
  viewModel.selectedErpAttributes = viewModel.selectAll ? props.items.filter((item) => item.erpAttributeValue !== "") : [];
  emits("update:selectedItems", viewModel.selectedErpAttributes);
};

const isIndeterminate = computed(() => {
  const selectedCount = sortedList.value.filter((item: any) => item.selected).length;
  return selectedCount > 0 && selectedCount < sortedList.value.length;
});

function handleCheckboxChange(e: any, parameter: any) {
  if (e) {
    viewModel.selectedErpAttributes.push(parameter);
  } else {
    viewModel.selectedErpAttributes = viewModel.selectedErpAttributes.filter((item: any) => item.attributeId !== parameter.attributeId);
  }
  const selectedCount = sortedList.value.filter((item: any) => item.selected).length;
  viewModel.selectAll = selectedCount === sortedList.value.length;
  emits("update:selectedItems", viewModel.selectedErpAttributes);
}

return (_ctx: any,_cache: any) => {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_checkbox = _resolveComponent("b-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { class: "ai-texter-search" }, {
            default: _withCtx(() => [
              _createVNode(CommonFilter, {
                modelValue: viewModel.searchTerm,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewModel.searchTerm) = $event)),
                placeholder: _ctx.$t('AiTexter.FilterByAttributeName'),
                "prepend-icon": "Filter",
                "trigger-by-time": ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (sortedList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_b_checkbox, {
                modelValue: viewModel.selectAll,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((viewModel.selectAll) = $event)),
                onChange: toggleSelectAll,
                indeterminate: isIndeterminate.value
              }, null, 8, ["modelValue", "indeterminate"])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["ai-texter-table-col value-col pl-0", { 'sorted-by': viewModel.sortBy.name == 'name' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setSortBy('name')))
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("AiTexter.Attribute")), 1),
              (viewModel.sortBy.name == 'name')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (!viewModel.sortBy.desc)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          icon: "ChevronBottom",
                          class: "font-weight-bolder"
                        }))
                      : _createCommentVNode("", true),
                    (viewModel.sortBy.desc)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 1,
                          icon: "ChevronTop",
                          class: "font-weight-bolder"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["ai-texter-table-col mid-col pl-0", { 'sorted-by': viewModel.sortBy.name == 'value' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (setSortBy('value')))
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("AiTexter.Value")), 1),
              (viewModel.sortBy.name == 'value')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (!viewModel.sortBy.desc)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          icon: "ChevronBottom",
                          class: "font-weight-bolder"
                        }))
                      : _createCommentVNode("", true),
                    (viewModel.sortBy.desc)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 1,
                          icon: "ChevronTop",
                          class: "font-weight-bolder"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["ai-texter-table-col small-col pl-0", { 'sorted-by': viewModel.sortBy.name == 'userType' }]),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (setSortBy('userType')))
            }, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("AiTexter.AttributeType")), 1),
              (viewModel.sortBy.name == 'userType')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (!viewModel.sortBy.desc)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 0,
                          icon: "ChevronBottom",
                          class: "font-weight-bolder"
                        }))
                      : _createCommentVNode("", true),
                    (viewModel.sortBy.desc)
                      ? (_openBlock(), _createBlock(Icon, {
                          key: 1,
                          icon: "ChevronTop",
                          class: "font-weight-bolder"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedList.value, (sortedItem) => {
              return (_openBlock(), _createElementBlock("div", {
                key: sortedItem.attributeId,
                class: "ai-texter-table-row"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_b_checkbox, {
                        modelValue: sortedItem.selected,
                        "onUpdate:modelValue": ($event: any) => ((sortedItem.selected) = $event),
                        onChange: (e) => handleCheckboxChange(e, sortedItem)
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                    ]),
                    _createElementVNode("div", {
                      class: "ai-texter-table-col value-col pl-0",
                      onClick: ($event: any) => (sortedItem.selected = !sortedItem.selected)
                    }, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(`${sortedItem.erpSectionName}/${sortedItem.erpAttributeName}`), 1)
                    ], 8, _hoisted_16),
                    _createElementVNode("div", {
                      class: "ai-texter-table-col mid-col pl-0",
                      onClick: ($event: any) => (sortedItem.selected = !sortedItem.selected)
                    }, [
                      _createElementVNode("span", _hoisted_19, _toDisplayString(`${sortedItem.erpAttributeValue} ${sortedItem.erpAttributeUnit}`), 1)
                    ], 8, _hoisted_18),
                    _createElementVNode("div", {
                      class: "ai-texter-table-col small-col pl-0",
                      onClick: ($event: any) => (sortedItem.selected = !sortedItem.selected)
                    }, [
                      _createElementVNode("span", _hoisted_21, _toDisplayString(sortedItem.erpAttributeType == "" ? `<${_ctx.$t("none")}>` : sortedItem.erpAttributeType), 1)
                    ], 8, _hoisted_20)
                  ])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createVNode(Alert, {
            "with-icon": "",
            show: "",
            variant: "info"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("AiTexter.NoERPAttributeAvailable")), 1)
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})